import api from 'config/axios';
import AppService from 'common/app-service';

import { IRegistersResponse, IRegisterRefreshPayload, IRegisterRefreshResponse } from 'common/register.interface';

export default class RegistersService extends AppService {
  constructor() {
    super('registers', api);
  }

  async registerCtes(registerData): Promise<IRegistersResponse> {
    const response = await this.api.post(this.root('register'), registerData);

    return response.data;
  }

  async refreshCtes(registerData: IRegisterRefreshPayload): Promise<IRegisterRefreshResponse> {
    const response = await this.api.post(this.root('refresh'), registerData);

    return response.data;
  }
}
